import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getVideoCarouselState } from '../store/selectors/videoCarouselSelector';
import VideoCarousel from '../VideoCarousel';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import videoCarouselReducer from '../store/reducers/videoCarousel';
import contentDatasource from '@gameday/core/datasources/content';
import contentGraphDatasource from '@gameday/core/datasources/contentGraph';
import scheduleDatasource from '@gameday/core/datasources/schedule';
import { useTranslate } from '@gameday/utils/hooks/useTranslate';

import dataAction from '../store/actions/VideoCarouselDataRequestAction';

import PropTypes from 'prop-types';
import { switchActiveTab } from '../../Final/store/actions/final';

const actions = (dispatch) => ({
    handleTabChange: (activeTab) => {
        dispatch(switchActiveTab(activeTab));
    }
});

initContainerData.register({
    datasources: {
        content: contentDatasource,
        contentGraph: contentGraphDatasource,
        schedule: scheduleDatasource
    },
    reducers: {
        videoCarousel: videoCarouselReducer
    }
});

const fetchData = () => {
    return dataAction();
};

const routes = [{
    path: '/',
    exact: false,
    fetchData
}];

const VideoCarouselDataContainer = ({
    handlers
}) => {
    const dispatch = useDispatch();
    const translate = useTranslate();
    const title = translate('label_top_highlights', 'Top Highlights');

    const {
        videoCarousel,
        deviceInteraction,
        isLoading,
        language,
        appPath
    } = useSelector(getVideoCarouselState);
    return (
        <VideoCarousel
            { ...videoCarousel }
            { ...actions(dispatch) }
            isLoading={ isLoading }
            deviceInteraction={deviceInteraction}
            handlers={ handlers }
            language={ language }
            appPath={ appPath }
            title={ title }
            showSeeAllLink={ true }
            width={'298px'}
        />
    );
};

VideoCarouselDataContainer.propTypes = {
    highlightClickHandler: PropTypes.func
};

export default VideoCarouselDataContainer;
export { fetchData, routes };
